import React from 'react';
import { Skeleton } from '@skin-seoul/design-system';

export const LoyaltyBannerSkeletonDesktop = () => {
  return (
    <div className="relative w-full h-[112px] rounded-[8px] bg-neutral-100 overflow-hidden">
      <div className="relative h-full flex items-center justify-between pl-4 pr-6 py-4 z-[1]">
        {/* Left Side - Title and Subtitle Skeleton */}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <Skeleton className="h-[20px] w-[120px]" />
            <Skeleton className="h-[20px] w-[100px]" />
          </div>
          <Skeleton className="h-[14px] w-[150px]" />
        </div>

        {/* Right Side - Points Skeleton */}
        <div className="flex flex-col gap-1 items-end">
          <Skeleton className="h-[14px] w-[80px]" />
          <Skeleton className="h-[24px] w-[100px]" />
        </div>
      </div>
    </div>
  );
};
